import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, HeartHandshake } from "lucide-react";
import { Link } from "react-router-dom";
import { createPageUrl } from "../../utils";
import { useLanguage } from "../../i18n";

export default function DonationCTA() {
  const { t } = useLanguage();
  return (
    <section className="relative py-20 sm:py-24 overflow-hidden bg-[#5b2229]">
      <div className="absolute inset-0 opacity-20 ethiopian-cross" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 mb-6">
            <HeartHandshake className="w-4 h-4 text-[#C9A227]" />
            <span className="text-[#C9A227] text-sm font-medium font-sans-clean">
              {t("home.stewardshipBadge")}
            </span>
          </div>

          <h2 className="font-serif-elegant text-4xl sm:text-5xl font-bold text-white mb-6">
            {t("home.stewardshipTitle")}
          </h2>

          <p className="text-lg sm:text-xl text-white/80 leading-relaxed font-sans-clean mb-8">
            {t("home.stewardshipBody")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={createPageUrl("Donations")}
              className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-lg bg-[#C9A227] text-[#722F37] font-sans-clean font-semibold text-sm sm:text-base hover:bg-[#A88520] transition-colors"
            >
              {t("home.stewardshipPrimary")}
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to={createPageUrl("Contact")}
              className="inline-flex items-center justify-center px-8 py-3 rounded-lg border border-white/40 text-white font-sans-clean text-sm sm:text-base hover:bg-white/10 transition-colors"
            >
              {t("home.stewardshipSecondary")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
